<template>


  <!--  <div class="nav-select" v-if="!accommodation.reserve_whole_object">
      <div class="nav-item" v-for="unit in accommodation.units.filter(u => u.hidden_for_reservation === false)">
        <div class="btn btn-first fw-bolder" v-if="selectedUnitTab === unit.id" aria-current="page"
             @click="changeSelectedTab(unit)">{{ unit.title }}</div>
        <div class="btn btn-outline-first" v-else aria-current="page"
             @click="changeSelectedTab(unit)">{{ unit.title }}</div>
      </div>
    </div>-->

  <template v-for="unit in accommodation.units">

    <!--    Dodikov novy cennik-->
    <div v-if="priceUnitTab === unit.id" class="card card-detail" :class="{'open': fullPriceList}">

      <div class="card-body">
        <div class="card-title">
          <div class="nazov">
            <h3 class="mb-0">{{ $t('prices-of-accommodations') }}</h3>
            <p>{{ $t('prices-of-accommodations-description') }}</p>
          </div>
        </div>

        <div class="nav-select" v-if="!accommodation.reserve_whole_object">
          <div class="nav-item" v-for="unit in accommodation.units.filter(u => u.hidden_for_reservation === false)">

            <div class="btn btn-first fw-bolder" v-if="priceUnitTab === unit.id" aria-current="page"
                 @click="priceUnitTab = unit.id">
              {{ unit.title }}
            </div>
            <div class="btn btn-outline-first" v-else aria-current="page"
                 @click="priceUnitTab = unit.id">
              {{ unit.title }}
            </div>
          </div>
        </div>

        <!-- cennik start-->
        <div class="price-item default-price"
             v-for="level in unit.price_levels.filter(p => typeof p.curr_prices === 'object' && Object.keys(p.curr_prices).length > 0 && Number(p.curr_prices[mainCurrency]) > 0)">

          <div class="prva">
            <p class="title">{{ level.title ? level.title : $t('polozka-bez-nazvu') }}</p>
            <p class="description days">
              {{ $t('valid-from') }}
              <span class="fw-semibold">{{ Number(level.date_from.day).pad() }}.{{
                  Number(level.date_from.month).pad()
                }}</span>
              {{ $t('valid-to') }}
              <span class="fw-semibold">{{ Number(level.date_to.day).pad() }}.{{
                  Number(level.date_to.month).pad()
                }}</span>
            </p>
            <p class="description nights">
              {{ $t('min') }} <span class="fw-semibold">{{
                level.min_nights
              }} {{ $t($vysklonujSlovo('noc', level.min_nights, 'i', 'och')) }}</span>
              {{ $t('a') }} {{ $t('min') }} <span class="fw-semibold">{{
                level.min_hosts
              }} {{ $t($vysklonujSlovo('host', level.min_hosts, 'ia', 'ia')) }}</span>
            </p>

          </div>

          <div class="druha">
            <p class="price">
              <span
                  v-if="typeof level.curr_prices === 'object' && Object.keys(level.curr_prices).length > 0">
                {{ level.curr_prices[mainCurrency] }} {{ mainCurrency }}
              </span>
              <span v-else>
                {{ $t('not-set') }}
              </span>
            </p>
            <p class="description for_acc">
              {{ $t('night') }} {{ $t('a') }} <span class="text-lowercase">{{
                $t('price-for-' + level.price_for)
              }}</span>
            </p>

            <p class="weekend-price d-none" v-if="typeof level.curr_prices_weekend === 'object' && !isNaN(level.curr_prices_weekend[mainCurrency]) && level.curr_prices_weekend[mainCurrency] > 0 && level.curr_prices_weekend[mainCurrency] != level.curr_prices[mainCurrency]">
              {{ level.curr_prices_weekend[mainCurrency] }} {{ mainCurrency }}
            </p>

          </div>
          <div class="tretia">
            <p class="description" v-if="level.note && level.note.length > 0">
              <span class="info">{{ $t('price-note') }}</span>
              {{ (accommodation.translations?.[activeLocale.code]?.price_note?.[level.id] ?? level.note) }}
            </p>

            <p class="description">
              <span class="wekend-price-note" v-if="typeof level.curr_prices_weekend === 'object' && !isNaN(level.curr_prices_weekend[mainCurrency]) && level.curr_prices_weekend[mainCurrency] > 0 && level.curr_prices_weekend[mainCurrency] != level.curr_prices[mainCurrency]">
              <span class="info-weekend">{{ $t('weekend-price-title') }} <span class="text-nowrap">{{ level.curr_prices_weekend[mainCurrency] }} {{ mainCurrency }} / {{ $t('night') }}</span>
              </span>
              </span>

            </p>
          </div>

        </div>
        <!-- cennik end -->

        <!-- default cena start -->
        <div class="price-item"
             v-if="accommodation.reserve_whole_object && accommodation.default_price_level.curr_prices[mainCurrency] !== undefined && Number(accommodation.default_price_level.curr_prices[mainCurrency]) > 0">
          <div class="prva">
            <p class="title">{{ $t('mimosezona') }}</p>

            <p class="description nights">
              {{ $t('min') }} <span class="fw-semibold">{{
                accommodation.default_price_level.min_nights
              }} {{ $t($vysklonujSlovo('noc', accommodation.default_price_level.min_nights, 'i', 'och')) }}</span>
              {{ $t('a') }} {{ $t('min') }} <span class="fw-semibold">{{ accommodation.default_price_level.min_hosts }} {{
                $t($vysklonujSlovo('host', accommodation.default_price_level.min_hosts, 'ia', 'ia'))
              }}</span>
            </p>
          </div>
          <div class="druha">
            <p class="price">
              {{ accommodation.default_price_level.curr_prices[mainCurrency] }} {{ mainCurrency }}
            </p>

            <p class="description for_acc">{{ $t('night') }} {{ $t('a') }} <span
                class="text-lowercase">{{ $t('price-for-' + accommodation.default_price_level.price_for) }}</span></p>
            

          </div>
          <div class="tretia">
            <p class="description">
              <span class="info">{{ $t('price-note') }}</span> {{ $t('mimosezona-popis') }}.

              <span class="wekend-price-note" v-if="typeof accommodation.default_price_level.curr_prices_weekend === 'object' && !isNaN(accommodation.default_price_level.curr_prices_weekend[mainCurrency]) && accommodation.default_price_level.curr_prices_weekend[mainCurrency] > 0 && accommodation.default_price_level.curr_prices_weekend[mainCurrency] != accommodation.default_price_level.curr_prices[mainCurrency]">
              <span class="info-weekend">{{ $t('weekend-price-title') }} <span class="text-nowrap">{{ accommodation.default_price_level.curr_prices_weekend[mainCurrency] }} {{ mainCurrency }} / {{ $t('night') }}</span>
              </span>
              </span>

            </p>



          </div>
        </div>
        <!-- default cena end -->

        <!-- doplnkove ceny start -->

        <div class="price-item"
             v-for="level in accommodation.price_additions.filter(a => a.curr_prices[mainCurrency] !== undefined)">
          <div class="prva">
            <p class="title">{{ additionTypes[level.code][activeLocale.code] }}</p>
          </div>
          <div class="druha">
            <p class="price">
              {{
                level.curr_prices[mainCurrency].to === -1 ? level.curr_prices[mainCurrency].from : `${level.curr_prices[mainCurrency].from} - ${level.curr_prices[mainCurrency].to}`
              }} {{ mainCurrency }}
            </p>
            <p class="description text-end">
              {{ priceForTypes[level.price_for][activeLocale.code] }}

            </p>
          </div>
          <div class="tretia">
            <p class="description" v-if="level.note && level.note.length > 0">
              <span class="info">{{ $t('price-note') }}</span> {{ level.note }}
            </p>
          </div>
        </div>
        <!-- doplnkove ceny end -->

        <div class="button-footer" v-if="unit.price_levels.length > 2">
          <button class="collapsed btn btn-silver btn-rounded"
                  @click="fullPriceList = !fullPriceList">
            {{ $t(fullPriceList ? 'show-less' : 'show-more') }}
          </button>
        </div>


      </div>

    </div>
  </template>


</template>

<script setup lang="ts">

import {PropType, ref} from "vue";
import Accommodation from "../../../../../lib/models/Accommodation";
import {useNuxtApp} from "#app";
import additionTypes from "~/lib/data/price_additions.json";
import priceForTypes from "~/lib/data/price_additions_price_for.json";

const props = defineProps({
  accommodation: Object as PropType<Accommodation>,
  activeLocale: Object as { code: string }
});

const mainCurrency = props.accommodation.main_currency;
const {$vysklonujSlovo} = useNuxtApp();
const fullPriceList = ref<boolean>(false);

const priceUnitTab = ref(props.accommodation.units && props.accommodation.units.length > 0 ? props.accommodation.units[0].id : -1);


</script>
